import React, { useState } from "react";
import cx from "classnames";
import Dialog from "rc-dialog";
import ReactTooltip from "react-tooltip";

// Simple functional component to wrap content (its children/components) into a trigger with optional dialog (popup) which will be triggered by a button (also has optional callback funciton)
export function WrapInDialogButton(props) {
    const [open, setOpen] = useState(props?.initialOpen || false);

    const callBack = (params) => {
        if (props.onClick && typeof props.onClick === "function") {
            props.onClick(params);
            setOpen(false);
        }
    };

    let children = (props.children?.length >= 0 ? props.children : [props.children]).filter((o) => !!o);

    // If the icon is provided as a string, expect it to be a `fa-` icon name.
    const icon = props.icon && typeof props.icon === "string" ? (props.icon.startsWith("fa-") ? props.icon : `fa-${props.icon}`) : "search";

    return (
        <>
            {props.buttonDisabled && props.disabledInfoText ? (
                <div data-tip data-for="tip-disabled-info-text">
                    <button disabled={props.buttonDisabled} className={cx({ "btn btn-primary": !props.className }, props?.className)} onClick={() => setOpen(true)}>
                        {props.buttonTitle}
                        {icon && <i className={cx("fa", icon)} />}
                    </button>
                    <ReactTooltip id="tip-disabled-info-text" effect="solid" place="right">
                        {props.disabledInfoText}
                    </ReactTooltip>
                </div>
            ) : (
                <button disabled={props.buttonDisabled} className={cx({ "btn btn-primary": !props.className }, props?.className)} onClick={() => setOpen(true)}>
                    {props.buttonTitle}
                    {icon && <i className={cx("fa", icon)} />}
                </button>
            )}
            {open && props?.triggerOnly && (
                <>
                    {children?.map((child, idx) => {
                        return React.cloneElement(child, {
                            key: idx,
                            fallbackCloseDialog: () => {
                                setOpen(false);
                            },
                            onClick: (params) => callBack(params)
                        });
                    })}
                </>
            )}

            {open && !props?.triggerOnly && (
                <Dialog title={props?.dialogTitle || ""} onClose={() => setOpen(false)} visible={open} style={props.style}>
                    {children?.map((child, idx) => {
                        return React.cloneElement(child, {
                            key: idx,
                            fallbackCloseDialog: () => {
                                setOpen(false);
                                if (props?.onClose && typeof props?.onClose === "function") {
                                    props.onClose();
                                }
                            },
                            onClick: (params) => callBack(params)
                        });
                    })}

                    {props?.noClose !== true && (
                        <div className="row">
                            <div className="mt-4 col-12">
                                <button className={"btn float-right btn-primary no-sideflap"} onClick={() => setOpen(false)}>
                                    {props?.primaryClose ? props.primaryClose : "Sluiten"}
                                </button>
                            </div>
                        </div>
                    )}
                </Dialog>
            )}
        </>
    );
}
